import { Home } from 'views/website/home';
import { Contact } from 'views/website/contact';
import { Pricing } from 'views/website/pricing';
import { Terms } from 'views/website/terms';
import { Privacy } from 'views/website/privacy';
import { PublicLabView } from 'views/website/PublicLabView/PublicLabView';

const Routes = [
  {
    path: '/',
    view: Home,
    layout: 'home',
    title: 'AIVAGAM - Platform to Gain FullStack Experience'
  },
  {
    path: '/contact',
    view: Contact,
    layout: 'home',
    title: 'Contact'
  },
  {
    path: '/pricing',
    view: Pricing,
    layout: 'home',
    title: 'Pricing'
  },
  {
    path: '/privacy',
    view: Privacy,
    layout: 'home',
    title: 'Privacy Policy'
  },
  {
    path: '/terms',
    view: Terms,
    layout: 'home',
    title: 'Terms & Conditions'
  },
  {
    path: '/mobile',
    view: PublicLabView,
    layout: 'home',
    title: "Mobile"
  },
  {
    path: '/public/:product/:id',
    view: PublicLabView,
    layout: 'home',
    hideNavItems: { contact: true },
    title: 'Course',
  }
]

export default Routes;